// Module external access for global module variables
export { sdkContainerInstance, getSdkContainer } from '../../global/Container';